import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
// import cx from 'classnames';

import { DAYS } from '~src/constants';

// import PriceSlider from '~components/forms/price-slider';
import PriceRange from '~components/forms/price-range';
import { Checkbox } from '~components/forms/checkbox';
import Collapsible from '~components/collapsible';
import { LanguageSelector } from '~components/forms/language-selector';
import { Availability } from '~components/forms/availability';
import { useHistory, useLocation } from 'react-router-dom';
import { LocationSearch } from '~components/forms/location';
import LocationContext from '../../locationContext';
import { preserveQueryParamsOnLocationChange } from '~components/listing/newMatchesParams';

import { UserContext } from '~contexts/user';
import PromptService from '~services/prompt';
import { useLocationDetails } from '~hooks/useLocationDetails';

import Attributes from './attributes';

const DesktopFilters = ({
  values,
  selectableLanguages,
  isCityPage = false,
  onChangePrice = () => {},
  onChangeScope = () => {},
  onChangeItem = () => {},
}) => {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  const { pricingDetails, locationDetails, isLoadingLocation, locationTouched, onChangeLocation } = useContext(LocationContext);
  const { user } = useContext(UserContext);
  const { fetchCustomerPaymentForLocation } = useLocationDetails();
  // const { locationDetails, isLoadingLocation, locationTouched, onChangeLocation } = useContext(LocationContext);

  const minPrice = pricingDetails?.minPrice || 0;
  const maxPrice = pricingDetails?.maxPrice || 4000;
  const currency = pricingDetails?.currency || 'EUR';
  // const step = maxPrice > 10000 ? 1 : 0.25;
  const step = 1;

  return (
    <div className="c-filters">
      <LocationSearch
        isDataLoading={isLoadingLocation}
        location={!isCityPage ? locationDetails : {}}
        placeholder={intl.formatMessage({
          id: 'containers.workers.subheader.address',
          defaultMessage: 'Address',
        })}
        name="address"
        className="c-autocomplete--focus-disabled"
        onSubmit={async (loc) => {
          if (loc && loc.place_id) {
            if (user?.personId && fetchCustomerPaymentForLocation) {
              const customerPaymentDetails = await fetchCustomerPaymentForLocation(user.personId);
              if (customerPaymentDetails && customerPaymentDetails.length > 0) {
                await PromptService.alert({
                  title: intl.formatMessage({
                    id: 'containers.wishes.edit.location-change-prompt.title',
                    defaultMessage: 'Changing the address',
                  }),
                  content: intl.formatMessage({
                    id: 'containers.wishes.edit.location-change-prompt.content',
                    defaultMessage:
                      'Changing your address might result in a an additional payment request just for the new workers for your new address.',
                  }),
                });
              }
            }
            history.push({
              pathname: '/workers',
              search: preserveQueryParamsOnLocationChange(location.search, loc.place_id),
              state: {
                location: {
                  locationId: loc.place_id,
                  address: loc.address,
                },
              },
            });
            if (!isCityPage && onChangeLocation) {
              onChangeLocation(loc.place_id);
            }
          }
        }}
      />
 
      {/* PRICE */}
      <div className="c-widget c-collapsible c-widget--price">
        <PriceRange 
          min={minPrice / 100}
          max={maxPrice / 100}
          currency={currency}
          step={step}
          location={locationDetails}
          onChange={(value) => {
            onChangePrice(value[1]);
          }}
          defaultValues={values.price * 0.01}
        />
        {/* <div className="l-headline--tertiary">
          {intl.formatMessage({ id: 'containers.workers.filters.price.label', defaultMessage: 'Hourly rate' })}
        </div>
        <div
          className={cx('c-matches-filter__content--price', {
            'c-matches-filter__content--price-no-euro': currency !== 'EUR',
          })}
        >
          <PriceSlider
            min={minPrice / 100}
            max={maxPrice / 100}
            currency={currency}
            step={step}
            onChange={(value) => {
              onChangePrice(value[0]);
            }}
            defaultValues={[values.price * 0.01]}
          />
        </div> */}
      </div>
      {/* LANGUAGES */}
      <Collapsible.Wrapper isExpanded={true}>
        <Collapsible.Header>
          {intl.formatMessage({ id: 'containers.workers.filters.languages.label', defaultMessage: 'Languages' })}{' '}
          {values.languages.length > 0 && `(${values.languages.length})`}
        </Collapsible.Header>
        <Collapsible.Content>
          <LanguageSelector
            languages={selectableLanguages}
            value={values.languages}
            onChange={(value) => onChangeScope('languages', value)}
          />
        </Collapsible.Content>
        <Collapsible.ContentCollapsed>
          {selectableLanguages.map((item) => {
            return values.languages.indexOf(item.value) >= 0 ? (
              <Checkbox
                label={intl.formatMessage({ id: `languages.${item.value}` })}
                key={item.value}
                checked={values.languages.indexOf(item.value) >= 0}
                onChange={() => onChangeItem('languages', item.value)}
              />
            ) : null;
          })}
        </Collapsible.ContentCollapsed>
      </Collapsible.Wrapper>
      {/* DAYS */}
      <Collapsible.Wrapper isExpanded={true}>
        <Collapsible.Header>
          {intl.formatMessage({ id: 'containers.workers.filters.days.label', defaultMessage: 'Days' })}{' '}
          {values.days.length > 0 && `(${values.days.length})`}
        </Collapsible.Header>
        <Collapsible.Content>
          <Availability value={values.days} onChange={(value) => onChangeScope('days', value)} />
        </Collapsible.Content>
        <Collapsible.ContentCollapsed>
          {DAYS.map(
            (item) =>
              values.days.indexOf(item) >= 0 && (
                <Checkbox
                  label={intl.formatMessage({ id: `days.long.${item}` })}
                  key={item}
                  checked
                  onChange={() => onChangeItem('days', item)}
                />
              )
          )}
        </Collapsible.ContentCollapsed>
      </Collapsible.Wrapper>
      {/* ATTRIBUTES */}
      <Collapsible.Wrapper isExpanded={true}>
        <Collapsible.Header>
          {intl.formatMessage({
            id: 'containers.workers.filters.attributes.label',
            defaultMessage: 'Requirements',
          })}{' '}
          {values.attributes.length > 0 && `(${values.attributes.length})`}
        </Collapsible.Header>
        <Collapsible.Content>
          <Attributes value={values.attributes} onChange={(value) => onChangeItem('attributes', value)} />
        </Collapsible.Content>
        <Collapsible.ContentCollapsed>
          {values.attributes.map((item) => (
            <Checkbox
              label={intl.formatMessage({ id: `containers.workers.filters.attributes.values.${item}` })}
              key={item}
              checked
              onChange={() => onChangeItem('attributes', item)}
            />
          ))}
        </Collapsible.ContentCollapsed>
      </Collapsible.Wrapper>
    </div>
  );
};

export default DesktopFilters;
